import React from 'react';
import { Icon } from '@gravity-ui/uikit';
import CircleCheckFill from '@gravity-ui/icons/CircleCheckFill';
import i18n from '@yandex-int/i18n';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { routes } from '../../lib/routes';
import { InstallableApp } from '../../model/skill';
import * as keyset from 'i18n/DraftControlPanel';
import { ErrorBoundary } from 'client/blocks/ErrorBoundary/ErrorBoundary';
import { IconMedium } from '../AppIcons/AppIcons';
import { ScreenshotBlock } from './ScreenshotBlock';
import { mapChannelToInstallableAppCard } from '../icons/InstallableAppIcons';

import styles from './InstallableAppCard.module.scss';

export interface InstallableAppCardProps {
    installableApp: InstallableApp;
}

const t = i18n(keyset);

export const InstallableAppCard = ({ installableApp }: InstallableAppCardProps) => {
    const channel = installableApp.channel;
    const content = mapChannelToInstallableAppCard?.[channel];
    if (installableApp.id === undefined || !content) {
        return null;
    }
    const logoUrl = installableApp?.logoUrl || installableApp?.draft?.logoUrl;
    const appName = installableApp?.draft?.name || installableApp?.name || '';
    const updatedAt = moment(installableApp?.updatedAt).format('DD.MM.YY');
    const screenshotUrl =
        installableApp?.screenshots?.[0]?.imageUrl || installableApp?.draft?.screenshots?.[0]?.imageUrl;

    return (
        <ErrorBoundary>
            <Link to={routes.app.installableAppSettings(installableApp.channel, false, 'main', installableApp.id)}>
                <div className={styles.installableAppCard__container}>
                    <div className={styles.installableAppCard__contentRow}>
                        <div className={styles.installableAppCard__titleContainer}>
                            <div className={styles.installableAppCard__iconWrapper}>
                                <IconMedium imageUrl={logoUrl} />
                            </div>
                            <h3 className={styles.installableAppCard__title}>{appName}</h3>
                        </div>
                        <ScreenshotBlock channel={channel} screenshotUrl={screenshotUrl} />
                    </div>
                    <div className={styles.installableAppCard__statusRow}>
                        <div className={styles.installableAppCard__channelIcon}>
                            {content.icon}
                            {content.label}
                        </div>
                        {installableApp.onAir && (
                            <div className={styles.publishedBlock}>
                                <Icon className={styles.publishedBlock__iconFillGreen} data={CircleCheckFill} />
                                <span className={styles.publishedBlock__text}>
                                    {t('published')} {updatedAt}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </Link>
        </ErrorBoundary>
    );
};
